export default "__VITE_ASSET__d766aecd__"